import React from 'react';
import { Container } from 'react-bootstrap';
import './CollectionSection.css';
import { Link } from 'react-router-dom';

const CollectionSection = () => {
  const imgs = {
    sunglasses: '/sunglasses.png',
    safety_glasses: '/Safety-Glasses.png',
    Eye_Exam: '/eye-exam.png',
    contact_lenses: '/contact-lenses-services.png',
    eye_glasses: '/eye-glasses.png',
    sports_goggles: '/sports-goggles.png',
  };

  return (
    <section className="collection-section">
      <div className="collection-bg-overlay" />
      <Container className="collection-container mx-auto">
        <h1 className='collection-header'>Our <span className='vision-accent'>Services</span></h1>
        <div className="collection-grid">
          <div className="collection-item collection-left">
            <Link to="/services/sunglasses" className="text-decoration-none ">
              <img src={imgs.sunglasses} alt="Sunglasses" />
              <div className="collection-caption">Sunglasses</div>
            </Link>
          </div>
          <div className="collection-item collection-left-addition">
            <Link to="/services/eye-exam" className="text-decoration-none">
              <img src={imgs.Eye_Exam} alt="Men" />
              <div className="collection-caption small ">Eye Exam</div>
            </Link>
          </div>
          <div className="collection-item collection-men">
            <Link to="/services/safety-glasses" className="text-decoration-none">
              <img src={imgs.safety_glasses} alt="Safety Glasses" />
              <div className="collection-caption small ">Safety Glasses</div>
            </Link>
          </div>
          <div className="collection-item collection-newArrival">
            <Link to="/services/eye-glasses" className="text-decoration-none">
              <img src={imgs.eye_glasses} alt="Eye Glasses" />
              <div className="collection-caption small">Eye Glasses</div>
            </Link>
          </div>

          <div className="collection-item collection-women">
            <Link to="/services/sports-goggles" className="text-decoration-none">
              <img src={imgs.sports_goggles} alt="Sports Goggles" />
              <div className="collection-caption small">Sports Goggles</div>
            </Link>
          </div>

          <div className="collection-item collection-sunglasses">
            <Link to="/services/contact-lenses" className="text-decoration-none">
              <img src={imgs.contact_lenses} alt="Contact Lenses" />
              <div className="collection-caption small">Contact Lenses</div>
            </Link>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default CollectionSection;
// (removed duplicate stub)